// AddVendorModal.jsx
// Modal for adding a new vendor

import React, { Component } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import VendorAPI from '../../../services/vendorService';
import { normalizeWebsite } from '../../../util/websiteUrl';

class AddVendorModal extends Component {
    state = {
        form: {
            vendor_name: '',
            contact_name: '',
            contact_email: '',
            contact_phone: '',
            website: '',
            lead_time_days: '',
            notes: ''
        },
        saving: false,
        error: null
    };

    handleChange = (field, value) => {
        this.setState(prev => ({
            form: { ...prev.form, [field]: value }
        }));
    };

    handleSave = async () => {
        const { form } = this.state;
        if (!form.vendor_name.trim()) {
            this.setState({ error: 'Vendor name is required.' });
            return;
        }

        let website;
        try {
            website = normalizeWebsite(form.website);
        } catch (e) {
            this.setState({ error: e.message });
            return;
        }

        this.setState({ saving: true, error: null });
        try {
            const payload = {
                ...form,
                website,
                installer_id: this.props.installerId,
                lead_time_days: form.lead_time_days ? parseInt(form.lead_time_days, 10) : null
            };
            await VendorAPI.createVendor(payload);
            this.props.onSaved();
            this.props.onHide();
        } catch (err) {
            console.error('Error creating vendor:', err);
            const serverMessage = err && err.response && err.response.data && err.response.data.message;
            this.setState({ saving: false, error: serverMessage || 'Failed to create vendor. Please try again.' });
        }
    };

    render() {
        const { show, onHide } = this.props;
        const { form, saving, error } = this.state;

        return (
            <Modal show={show} onHide={onHide} centered backdrop={saving ? 'static' : true}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="fa-sharp fa-regular fa-truck-field mr-2"></i>
                        Add Vendor
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {error && <div className="alert alert-danger">{error}</div>}

                    <Form.Group className="mb-3">
                        <Form.Label>Vendor Name <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                            type="text"
                            value={form.vendor_name}
                            onChange={(e) => this.handleChange('vendor_name', e.target.value)}
                            placeholder="e.g. XPEL, SunTek, 3M"
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Contact Name</Form.Label>
                        <Form.Control
                            type="text"
                            value={form.contact_name}
                            onChange={(e) => this.handleChange('contact_name', e.target.value)}
                        />
                    </Form.Group>

                    <div className="d-flex" style={{ gap: '12px' }}>
                        <Form.Group className="mb-3 flex-fill">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                value={form.contact_email}
                                onChange={(e) => this.handleChange('contact_email', e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3 flex-fill">
                            <Form.Label>Phone</Form.Label>
                            <Form.Control
                                type="text"
                                value={form.contact_phone}
                                onChange={(e) => this.handleChange('contact_phone', e.target.value)}
                            />
                        </Form.Group>
                    </div>

                    <Form.Group className="mb-3">
                        <Form.Label>Website</Form.Label>
                        <Form.Control
                            type="text"
                            inputMode="url"
                            maxLength={500}
                            placeholder="e.g. diydetail.com"
                            value={form.website}
                            onChange={(e) => this.handleChange('website', e.target.value)}
                        />
                        <Form.Text className="text-muted">For online stores — where you reorder.</Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Lead Time (days)</Form.Label>
                        <Form.Control
                            type="number"
                            min="0"
                            value={form.lead_time_days}
                            onChange={(e) => this.handleChange('lead_time_days', e.target.value)}
                            placeholder="Average delivery days"
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Notes</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            value={form.notes}
                            onChange={(e) => this.handleChange('notes', e.target.value)}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide} disabled={saving}>Cancel</Button>
                    <Button
                        style={{ backgroundColor: 'var(--color-brand-teal)', borderColor: 'var(--color-brand-teal)' }}
                        onClick={this.handleSave}
                        disabled={saving}
                    >
                        {saving ? (
                            <><i className="fa-sharp fa-regular fa-spinner fa-spin mr-2"></i>Saving...</>
                        ) : (
                            'Add Vendor'
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default AddVendorModal;
